import elementService from "@/common/ElementService";

export default new class ProductDetailQuestionTogglerService {
    public init(): void {
        for (const questionSection of document.querySelectorAll<HTMLDivElement>(".product-detail-question-section")) {
            this.initQuestionSectionToggler(questionSection);
        }
    }

    private initQuestionSectionToggler(questionSection: HTMLDivElement): void {
        const heading = elementService.elementQuerySelector<HTMLDivElement>(questionSection, ".product-detail-question-section-heading");

        heading.addEventListener("click", () => this.toggleSection(questionSection));
    }

    private toggleSection(questionSection: HTMLDivElement): void {
        const headingArrow = elementService.elementQuerySelector<HTMLDivElement>(questionSection, ".product-detail-question-section-heading-arrow");
        const content = elementService.elementQuerySelector<HTMLDivElement>(questionSection, ".product-detail-question-section-content");

        const isActive = headingArrow.classList.contains("active");

        headingArrow.classList.toggle("active", !isActive);
        content.classList.toggle("hidden", isActive);
    }
}();
